import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ScreenshotToGif from './screenshot-to-gif';

import useThumbnail from './hooks/useThumbnail';
import FoxPoint from './assets/fox-point';

function SiteScreenshot({
  className,
  lighthouse,
  friendlyTestUrl,
  showFox,
  imageBackgroundColor,
  parentControlShowClip,
  parentControlStartClip,
  parentControlStopClip,
}) {
  const {
    desktop, mobile, start, stop, showClip,
  } = useThumbnail(lighthouse);
  const [mobileReady, updateMobileReady] = useState(false);
  const [desktopReady, updateDesktopReady] = useState(false);

  useEffect(() => {
    if (parentControlStartClip && parentControlStopClip) {
      if (parentControlShowClip) {
        start();
      } else {
        stop();
      }
    }
  }, [parentControlStartClip, parentControlStopClip, parentControlShowClip, start, stop]);

  return (
    <Wrapper
      onClick={() => {
        if (mobileReady && desktopReady) {
          if (parentControlStartClip && parentControlStopClip) {
            if (parentControlShowClip) {
              parentControlStopClip();
            } else {
              parentControlStartClip();
            }
          } else if (showClip) {
            stop();
          } else {
            start();
          }
        }
      }}
    >
      <div>
        <HeroImageWrapper inline={!showFox}>
          <DesktopHeroImage
            imageBackgroundColor={imageBackgroundColor}
            id={`desktop-image-${friendlyTestUrl}`}
            className={className}
            image={desktop.data}
            timing={desktop.timing}
            showClip={showClip}
            alt={`${friendlyTestUrl}-desktop`}
            updateReady={updateDesktopReady}
            inline={!showFox}
          />
          <MobileHeroImage
            imageBackgroundColor={imageBackgroundColor}
            id={`mobile-image-${friendlyTestUrl}`}
            className={className}
            image={mobile.data}
            timing={mobile.timing}
            showClip={showClip}
            alt={`${friendlyTestUrl}-mobile`}
            updateReady={updateMobileReady}
            inline={!showFox}
            isMobile
          />
        </HeroImageWrapper>
        { showFox && (<Fox />)}
      </div>
    </Wrapper>
  );
}

SiteScreenshot.defaultProps = {
  showFox: true,
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
`;

const Fox = styled(FoxPoint)`
  position: absolute;
  right: 0;
  top: 5.0rem;
  height: 7rem;
  width: auto;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    height: 16rem;
  }
`;

const HeroImageWrapper = styled.div`
  ${(props) => (props.inline ? `
    display: flex;
  ` : '')}
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    margin-right: 13rem;
    ${(props) => (props.inline ? `
      margin-right: unset;
    ` : '')}
  }
`;

const DesktopHeroImage = styled(ScreenshotToGif)`
  @media all and (max-width: ${(props) => props.theme.breakingpoints.md}) {
    max-width: 70%;
  }
  max-width: calc(100% - 8px);
  max-height: 100%;
  margin-right: 1em;
`;

const MobileHeroImage = styled(ScreenshotToGif)`
  position:   ${(props) => (props.inline ? 'unset' : 'absolute')};
  max-height: 250px;
  line-height: 1;
  
  ${(props) => props.inline && props.isMobile ? 'z-index: 2;' : null}
  
  @media all and (max-width: ${(props) => props.theme.breakingpoints.md}) {
    right: 30rem;
    top: 13rem;
    height: 70%;
    top: 4rem;
    max-height: 100%;
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    bottom: ${(props) => (props.inline ? 'unset' : 0)};
    right: ${(props) => (props.inline ? 'unset' : '30rem')};
    top: ${(props) => (props.inline ? 'unset' : '13rem')};
  }
`;

export default SiteScreenshot;
